import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="created-by text-center">
      <a href="https://badungkab.go.id" target="_blank"
        >Pemerintah Kabupaten Badung</a
      >
      &copy; {{ currentYear }}
    </div>
    <div class="mt-2">
      <a routerLink="/privacy-policies">Kebijakan Privasi</a>
    </div>
  `,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
